<template>
  <header :class="{'page-header': true, 'page-header-collapsed': collapsed}">
    <div class="page-title-wrapper">
      <h1 class="page-title">{{$route.meta.title}}</h1>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: ['collapsed'],
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Header/Header.vue